
import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { useDispatch, useSelector } from "react-redux";
import { MenuLink, MobileMainMenu, DrawerBox, DrawerDivider, Humburgger, HumburggerClose, MenuButton, MenuButtonClose } from "../styles";
import styled from "@emotion/styled";
import eth from "../../../../assets/images/log.png"
import logo from "../../../../assets/images/logo.png"
import { ThemeContext, useTheme } from "@emotion/react";
import { P } from '../../../Styles/style';
const Connect = styled.div`
  color: #fff;
  border:1px solid #ba48ba ;
    font-family: "P-SM";
  border-radius: 10px;
display: flex;
align-items: center;
cursor:pointer;
font-size:20px !important ;
`
const Ethimg = styled.img`
 width: 100%;
 max-width: 27px;

`
const SpanEth = styled.div`
  color: #fff;
  background:linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%);
    padding: 11px 10px 3px;
  border-radius: 10px;

`
const MobileMenu = (props) => {
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [getAddress, setAddress] = useState('connecting');

  useEffect(() => {
    const initWeb3 = async () => {
      if (window.ethereum) {
        try {
          const web3 = new Web3(window.ethereum);
          const accounts = await web3.eth.getAccounts();
          setWeb3(web3);
          setAccount(accounts[0]);
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log('Please install MetaMask!');
      }
    };
    initWeb3();

    const handleAccountsChanged = (accounts) => {
      if (accounts.length === 0) {
        setAccount(null);
      } else {
        setAccount(accounts[0]);
      }
    };

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      }
    };
  }, []);
  useEffect(() => {
    if (account) setAddress(`${account.slice(0, 4)}...${account.substr(38 - 0)}`)
  }, [account])


  console.log("account metamask", getAddress);
  const theme = useTheme()
  const currentTheme = useSelector((state) => state.LDTheme.value)
  const dispatch = useDispatch();
  const [state, setState] = useState({ left: false });

  const toggleDrawer = (anchor, open) => (event) => {
    console.log('thest: ', anchor + " : " + open)
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) { return; }
    setState({ ...state, [anchor]: open });
  };

  return (
    <MobileMainMenu>
      <img src={logo}/>
      {/* <MenuButton onClick={toggleDrawer("left", true)}>
        <Humburgger></Humburgger> &nbsp;Menu
      </MenuButton> */}
      {/* <Connect><SpanEth><Ethimg src={eth} /></SpanEth> Connect Wallet</Connect> */}
      <div>
        {account ? (
          <Connect><SpanEth><Ethimg src={eth} /></SpanEth>&nbsp;&nbsp;{getAddress}&nbsp;&nbsp;</Connect>
        ) : (
          <Connect><SpanEth><Ethimg src={eth} /></SpanEth> <button style={{
            fontFamily: "P-SB" ,fontSize:"15px",padding:"0 20px", cursor:"pointer",backgroundColor: "transparent", color: "#fff", border: "none"
          }} onClick={() => window.ethereum.enable()}>Connect Wallet</button></Connect>

        )}
      </div>
      {/* <Connect><SpanEth><Ethimg src={eth} /></SpanEth> <CustomWeb3Button/></Connect> */}
      <Drawer anchor="left" open={state["left"]} onClose={toggleDrawer("left", false)}>
        <DrawerBox role="presentation" onClick={toggleDrawer("left", false)} onKeyDown={toggleDrawer("left", false)} >
          <DrawerDivider>
            <MenuButtonClose bgcolor={theme.textPrimary} onClick={toggleDrawer("left", true)}>
              <HumburggerClose>Close</HumburggerClose>
              &nbsp;Close
            </MenuButtonClose>
            {/* <Divider /> */}
            <List>
              {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass + " d-block"}>{value.title}</MenuLink>)}
            </List>
          </DrawerDivider>
          <DrawerDivider>
          </DrawerDivider>
        </DrawerBox>
      </Drawer>
    </MobileMainMenu>
  );
}

export default MobileMenu;

